<template>
    <div>
        <b-button
            variant="info"
            @click.stop="abrirModal()"
            :disabled="comprometimentosSelecionados.length == 0"
        >
            <span><i class="fa fa-edit mr-2"></i> Atualizar Históricos</span>
        </b-button>
        <b-modal
            id="modalAtualizarHistorico"
            v-model="mostrarModal"
            @show="preencherForm()"
        >
            <div slot="modal-title">
                Atualizar Históricos
            </div>
            <b-row>
                <b-col sm="12">
                    <b-form-checkbox
                        v-model="historicosPadroes"
                        :value="true"
                        :unchecked-value="false"
                    >
                        Retornar históricos padrões
                    </b-form-checkbox>
                </b-col>
            </b-row>
            <b-alert show v-if="historicosPadroes == false" class="mt-4">
                <b-row>
                    <b-col>
                        O texto informado será acrescido ao início do texto
                        padrão do histórico gerado pelo GESCON.
                    </b-col>
                </b-row>
            </b-alert>
            <b-row v-if="historicosPadroes == false">
                <b-col sm="12">
                    <b-form-group>
                        <label>Histórico</label>
                        <b-form-textarea
                            v-model="historico"
                            :rows="4"
                            @input="$v.historico.$touch()"
                            :state="$v.historico.$error ? false : null"
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >O histórico do movimento é
                            obrigatório</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="$v.$invalid"
                    @click.stop="confirmarSalvar()"
                    class="ml-1"
                    >Salvar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import ComprometimentosServicos from './ComprometimentosServicos'

export default {
    components: {},

    props: {
        contrato: {
            type: Object,
            default: () => ({})
        },

        comprometimentosSelecionados: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            mostrarModal: false,
            historico: null,
            historicosPadroes: false
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },

        preencherForm() {},

        confirmarSalvar() {
            this.$swal({
                title: 'Histórico do Movimento',
                html: `Confirma a atualização do histórico dos comprometimentos selecionados?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.salvar()
                }
            })
        },

        salvar() {
            this.$store.dispatch('addRequest')
            let atualizarHistoricosDto = {
                idContrato: this.contrato.idContrato,
                comprometimentos: this.comprometimentosSelecionados,
                historico: this.historico,
                historicosPadroes: this.historicosPadroes
            }
            ComprometimentosServicos.atualizarHistoricos(
                atualizarHistoricosDto
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Históricos atualizados com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('atualizarComprometimentos')
                    } else {
                        this.$emit('atualizarErros', response.errors)
                    }
                }
                this.fecharModal()
                this.$store.dispatch('removeRequest')
            })
        }
    },

    created() {},

    computed: {},

    watch: {},

    validations: {
        historico: {
            historicoOk() {
                if (!this.historicosPadroes) {
                    return this.historico != null && this.historico != ''
                }
                return true
            }
        }
    }
}
</script>
